import { Box } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import AudiIcon from '../../../../assets/icons/fleet/brands/audi.svg';
import FiatIcon from '../../../../assets/icons/fleet/brands/fiat.svg';
import HondaIcon from '../../../../assets/icons/fleet/brands/honda.svg';
import HyundaiIcon from '../../../../assets/icons/fleet/brands/hyundai.svg';
import JeepIcon from '../../../../assets/icons/fleet/brands/jeep.svg';
import MercedesIcon from '../../../../assets/icons/fleet/brands/mercedes-benz.svg';
import NissanIcon from '../../../../assets/icons/fleet/brands/nissan.svg';
import PeugeotIcon from '../../../../assets/icons/fleet/brands/peugeot.svg';
import ToyotaIcon from '../../../../assets/icons/fleet/brands/toyota.svg';
import VolvoIcon from '../../../../assets/icons/fleet/brands/volvo.svg';
import MitsubshiIcon from '../../../../assets/icons/fleet/brands/mitsubishi.svg';
import RenaultIcon from '../../../../assets/icons/fleet/brands/renault.svg';
import ChevroletIcon from '../../../../assets/icons/fleet/brands/chevrolet.svg';
import FordIcon from '../../../../assets/icons/fleet/brands/ford.svg';

import useStyles from './styles';

const brandIcons = {
  fiat: FiatIcon,
  audi: AudiIcon,
  honda: HondaIcon,
  hyundai: HyundaiIcon,
  jeep: JeepIcon,
  mercedes: MercedesIcon,
  'mercedes benz': MercedesIcon,
  nissan: NissanIcon,
  peugeot: PeugeotIcon,
  toyota: ToyotaIcon,
  volvo: VolvoIcon,
  chevrolet: ChevroletIcon,
  ford: FordIcon,
  renault: RenaultIcon,
  mitsubishi: MitsubshiIcon,
};

interface ICarBrandIconProps {
  name: string;
  label?: string;
  value: string;
  active: boolean;
  onClick(value: string): void;
}

const CarBrandIcon = (props: ICarBrandIconProps) => {
  const classes = useStyles();

  const handleClick = () => {
    props.onClick(props.value);
  };
  const icon: any = (brandIcons as any)[props.value];

  return (
    <>
      <Box className={classes.root} onClick={handleClick}>
        {icon && (
          <img className={classes.img} src={icon} alt="icon-button"></img>
        )}
        <Typography className={classes.text}>{props.label}</Typography>
      </Box>
    </>
  );
};
export default CarBrandIcon;
